import React, { useState, useEffect } from "react";
import classes from "./sesearchevent.module.scss";
import {
    FormControlLabel,
    Checkbox,
    FormControl,
    TextField,
    Button,
    Grid,
    Box,
    Typography,
    InputLabel,
    Select
  } from '@mui/material';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
    
import { Icon, DatePicker, Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString, toUpperCaseString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import { CalIcon } from "../../../../Resources/availabilityicon/IconUtils";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import warning_delete from "../../../../Resources/warning_delete.png";
import moment from 'moment';

const SESearchEventsPage = () => {
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const history = useNavigate();
    const [divSelectedValue, setDivSelectedValue] = useState(null);
    const [eventName, setEventName] = useState("");
    const [location, setLocation] = useState("");
    const [eventId, setEventId] = useState("");
    const [selectedDateType,setSelectedDateType] = useState(null);
    const [eventStartDate, setEventStartDate] = useState(null);
    const [eventEndDate, setEventEndDate] = useState(null);
    const [displayStartDate, setDisplayStartDate] = useState(null);
    const [displayEndDate, setDisplayEndDate] = useState(null);
    const [searchApiValue, setSearchApiValue] = useState([]);
    const [searchValue, setSearchValue] = useState([]);
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [toggledUnconfiguredEvents,setToggledUnconfiguredEvents] = useState(false)

    const ITEM_HEIGHT = 48;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openOption = Boolean(anchorEl);
    const dialog = useToggle();

    // action options
    const options = [
      'Edit',
      'Add',
      'Duplicate',
      'Delete',    
    ];

    // check user role at page
    CheckIsUserAdmin();

  const onDateTypeSelect = (dateType) => {
    console.log((dateType.target.value) + 'Checking this')
    setSelectedDateType(dateType.target.value)
  }

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  }

  const deleteLocation = useLocation();
  
  // option menu callbacks

  const toggleUnconfigured = (event) => {
      if(toggledUnconfiguredEvents) {
        setToggledUnconfiguredEvents(false)
      } 
      else {
        setToggledUnconfiguredEvents(true)
      }
      
  }

  const handleClick = (event,data) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(data);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  const handleOptionMenuClick = (event) => {
    setAnchorEl(null);
    let optionClicked = event.nativeEvent.target.outerText;
    let myData = selectedRowData;
    
    if(optionClicked == 'Edit'){
      history("EventDetails", { state: {data: myData, flag: "E"}});
    }

    if(optionClicked == 'Add'){
      history("EventDetails", { state: {data: myData, flag: "A"}});
    }

    if(optionClicked == 'Duplicate'){
      history("EventDetails", { state: {data: myData, flag: "C"}});
    }

    if(optionClicked == 'Delete'){
     // setCurrentRowData(myData)
     dialog.show();
    }

    

  }


  useEffect(() => {
    if(deleteLocation.state !== null && deleteLocation.state === "DeleteLocation"){
      setAlertOpen({
        open: true,
        severity: "success",
        message: "Event location deleted successfully.",
    })
    }

  }, []);
    
  const columns = [
    { field: 'division', headerName: 'Division', width: "120" },
    { field: 'location', headerName: 'Location', width: "100" },
    { field: 'eventname', headerName: 'EventName', width: "160",  renderCell: (params) => {
    console.log("params",params.row.id)
    var result = searchApiValue.find(function(e) {
      return e.recordSequenceId == params.row.id;
    });
   return( <>
    {params.row.eventname}
  </>) 
     }
    },
    { field: 'eventid', headerName: 'EventID', width: "100" },
    { field: 'eventstartdate', headerName: 'EventStartDate', width: "120" },
    { field: 'eventenddate', headerName: 'EventEndDate', width: "120" },
    { field: 'displaystartdate', headerName: 'DisplayStartDate', width: "120" },
    { field: 'displayenddate', headerName: 'DisplayEndDate', width: "120" },
    { field: 'status', headerName: 'Status', width: "120", renderCell: (params) => {
      if(toUpperCaseString(params.row.status) === "ACTIVE") {
        return (
        <div
          className="d-flex justify-content-between align-items-center"
          
        >
        <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
        </div>);
      } else {
      return (
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
        <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
        </div>
      
      );
      }
    }},
    { field: 'actions', headerName: 'Actions', width: "120", renderCell: (params) => {
      //let data= params.row;
      var result = searchApiValue.find(function(e) {
        return e.recordSequenceId == params.row.id;
      });
      return( <div>
    <IconButton
      aria-label="more"
      id="long-button"
      aria-controls={openOption ? 'long-menu' : undefined}
      aria-expanded={openOption ? 'true' : undefined}
      aria-haspopup="true"
      onClick={(event) => handleClick(event, result)}
    >
      <MoreVertIcon /> <div></div>
    </IconButton>
    <Menu
      id="long-menu"
      MenuListProps={{
        'aria-labelledby': 'long-button',
      }}
      anchorEl={anchorEl}
      open={openOption}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: '15ch',
        },
      }}
    >
      {options.map((option) => (
        <>
        {console.log(selectedRowData)}
        {(selectedRowData && (selectedRowData.locNbr !== null) || (selectedRowData == null || option === "Add")) &&
        <MenuItem key={option} disabled={selectedRowData && 
                  (selectedRowData.locNbr === 0 && option === 'Delete') ||
                  (selectedRowData && (moment(selectedRowData.eventEndDate).isBefore(moment().format('L')) 
                  ))} 
                  value={option} className={classes.menu_item} onClick={(event) => handleOptionMenuClick(event)} >
          {option}
        </MenuItem>
        }
        </>
      ))}
    </Menu>
  </div>)
    
      }},
    
  ];


  const deleteEventLocation = () => {
    // call delete api

    let data = {
        locId: selectedRowData.locId,
        locNbr: selectedRowData.locNbr,
        eventId: selectedRowData.eventId,
    }

    axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DELETE_ADMIN_EVENT_LOCATION_CONTROLS_BY_EVENT_AND_LOCID}`,
        data,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }).then((res) => {
            dialog.hide();
            setAlertOpen({
              open: true,
              severity: "success",
              message: "Event location deleted successfully.",
          })
          handleSearch()
        }).catch((err) => {
            
    });   

    
}


  const handleAlertNotifClose = () => {
     setAlertOpen({});
  };


   const handleSearch = () => {
    let searchData = [];
    let displayOrEvent;
    if(selectedDateType === "Display Date") {
      displayOrEvent = "display"
    } 
    if (selectedDateType === "Event Date") {
      displayOrEvent = "event"
    }
    
    if(divSelectedValue === null) {
      setAlertOpen({
        open: true,
        severity: "error",
        message : "Please Select Division",
      })
    } else {
      //need to add toggledUnconfiguredEvents as a variable for search now that i have the visual change
      let esd = eventStartDate !== null ? convertDateToMMDDYYYYString(eventStartDate,'/') : eventStartDate
      let eed = eventEndDate !== null ? convertDateToMMDDYYYYString(eventEndDate,'/') : eventEndDate
      let dsd = displayStartDate !== null ? convertDateToMMDDYYYYString(displayStartDate,'/') : displayStartDate
      let ded = displayEndDate !== null ? convertDateToMMDDYYYYString(displayEndDate,'/') : displayEndDate
    let data = {
      divNbr: divSelectedValue.divNbr,
      eventName: eventName != "" ? eventName : null,
      locNbr: location != "" ? location : null,
      eventId: eventId != "" ? eventId : null,
      eventStartDate: displayOrEvent === "event" ? dsd : null,
      eventEndDate: displayOrEvent === "event" ? ded : null,
      displayStartDate: displayOrEvent === "display" ? dsd : null,
      displayEndDate: displayOrEvent === "display" ? ded : null,
      includeUnconfiguredEvents: toggledUnconfiguredEvents ? "y":"n"
  }


   axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_GET_EVENT_DETAILS_ON_SEARCH_EVENT}`, 
   data,
    {
      headers:{
      'Content-Type': 'application/json',
      'Authorization':'Bearer ' + token,
      }
    }).then((res) => {
      
      let tmparr = []
      //console.log("response",res.data);
      res.data.map(obj => {
        let tmpobj = {}
        console.log("obj",obj)
        tmpobj.id = obj.recordSequenceId;
        tmpobj.division = obj.divNbr + "-" + obj.divName;
        tmpobj.location = obj.locNbr;
        tmpobj.eventname = obj.eventName;
        tmpobj.eventid = obj.eventId;
        tmpobj.eventstartdate = obj.eventStartDate;
        tmpobj.eventenddate = obj.eventEndDate;
        tmpobj.displaystartdate = obj.displayStartDate;
        tmpobj.displayenddate = obj.displayEndDate;
        tmpobj.status = obj.activeFlag === 'y' ? 'Active' : 'Inactive';
        tmparr.push(tmpobj);
      });
      setSearchApiValue(res.data);
      setSearchValue(tmparr);
      //console.log(tmparr)
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_EVENT_CONTROL_GET_EVENT_DETAILS_ON_SEARCH_EVENT}...failed`})
        }
    });
  }
    
  }

 
return(<div className={classes.pagemargin}>
        <div className={classes.pagetitle} >Search Event Location</div>      
        <div className={classes.searchbox}>

        <Box>
                <Dialog
                    open={dialog.open}
                    title={'Confirm Delete Event Location'}
                    onClose={dialog.hide}
                    
                    actions={
                        
                        <>
                            {selectedRowData && selectedRowData.locNbr !== 0 &&
                            <>
                            <Button color="secondary" onClick={dialog.hide}>No</Button>
                            <Button onClick={deleteEventLocation}>Yes</Button>
                            </>
                            }
                            {selectedRowData && selectedRowData.locNbr === 0 &&
                            <>
                            <Button  onClick={dialog.hide}>Ok</Button>
                            
                            </>
                            }
                        </>
                        
                        
                    }
                    
                >
                    {selectedRowData && selectedRowData.locNbr !== 0 && 
                    <Typography>Are you sure you want to delete this event location?</Typography>
                    }
                    {selectedRowData && selectedRowData.locNbr === 0 && 
                    <Typography style={{color:"red"}}><img src={warning_delete}/> You cannot delete Location 0. You need to delete the entire event.</Typography>
                    }
                </Dialog>
            </Box>
        
        <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>

    <Grid container spacing={3} columns={16}>        
    <Grid key={0} item xs={3}>
      <DivisionDropDownComp
      onDivChange={e => onDivDropDownSelect(e)}>
      </DivisionDropDownComp>
    </Grid>
    <Grid key={1} item xs={3}>
    <FormControl  style={{minWidth: '100%'}}>
      <TextField 
      label="Event Name (Opt)"
      onChange={(e) => setEventName(e.target.value)}
      value={eventName}
       />
    </FormControl>
    </Grid>
    
    {/*<Grid key={2} item xs={2}>
    <FormControl  style={{minWidth: '100%'}}>
    <DatePicker
      label="Event Start Date (Opt)"
      renderInput={(params) => (
        <TextField {...params}  />
      )}
      inputFormat="MM/dd/yyyy"
      value={eventStartDate}
      onChange={(newValue) => {
        setEventStartDate(newValue);
      }}
      // components={{
      //  OpenPickerIcon: CalIcon
      //  }}
      showDaysOutsideCurrentMonth
    />
    </FormControl>
    </Grid>*/}
   {/* <Grid key={3} item xs={2}>
    <FormControl  style={{minWidth: '100%'}}>
    <DatePicker
      label="Event End Date (Opt)"
      renderInput={(params) => (
        <TextField {...params}  />
      )}
      inputFormat="MM/dd/yyyy"
      value={eventEndDate}
      onChange={(newValue) => {
        setEventEndDate(newValue);
      }}
      // components={{
      //  OpenPickerIcon: CalIcon
      //  }}
    />
    </FormControl>
    </Grid>*/}
    
     <Grid key={2} item xs={3}>
    <FormControl  style={{minWidth: '100%'}}>
      <TextField 
      label="Location (Opt)"
      type="number"
      value={location}
      onChange={(e) => setLocation(e.target.value)}
       />
    </FormControl>
    </Grid>      
    <Grid key={3} item xs={3}>
    <FormControl  style={{minWidth: '100%'}}>
      <TextField 
      label="Event ID (Opt)"
      type="number"
      value={eventId}
      onChange={(e) => setEventId(e.target.value)} />
    </FormControl>
    </Grid>


    <Grid key={4} item xs={4}/>
    <Grid key={5} item xs={3}>
    <FormControl sx={{ minWidth: '100%'}}>
        <InputLabel id="demo-select-basic-label">Search By (Opt)</InputLabel>
        <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Search By (Opt)" 
        onChange={e => onDateTypeSelect(e)}
        value={selectedDateType || ''}
         >
          <MenuItem key={1} value={"Display Date"}>Display Date</MenuItem>
          <MenuItem key={2} value={"Event Date"}>Event Date</MenuItem>
        </Select>
        </FormControl>
    </Grid>
    <Grid key={6} item xs={3}>
    <FormControl  style={{minWidth: '100%'}}>
    <DatePicker
      label="Start Date (Opt)"
      renderInput={(params) => (
        <TextField {...params}  />
      )}
      inputFormat="MM/dd/yyyy"
      value={displayStartDate}
      onChange={(newValue) => {
        //console.log("Display Start Date: =>" + newValue.toDateString().split(" ")[1] + " "+ newValue.toDateString().split(" ")[2] +", " +newValue.toDateString().split(" ")[3] );
        setDisplayStartDate(newValue);
      }}
      // components={{
      //  OpenPickerIcon: CalIcon
      //  }}
      showDaysOutsideCurrentMonth
    />
    </FormControl>
    </Grid>  
    <Grid key={7} item xs={3}>
    <FormControl  style={{minWidth: '100%'}}>  
    <DatePicker
      label="End Date (Opt)"
      renderInput={(params) => (
        <TextField {...params}  />
      )}
      inputFormat="MM/dd/yyyy"
      value={displayEndDate}
      onChange={(newValue) => {
        setDisplayEndDate(newValue);
      }}
      // components={{
      //  OpenPickerIcon: CalIcon
      //  }}
      showDaysOutsideCurrentMonth
    />
    </FormControl>
    </Grid>
    <Grid key = {7} item xs={3.2}>
    <FormControlLabel
      value="top"
      control={
        <Checkbox
           sx={{ '& .MuiSvgIcon-root': { fontSize: 22 } }}                      
           onClick={toggleUnconfigured}                      
           checked = {toggledUnconfiguredEvents}                     
         />                                               
                } 
        sx={{fontSize:12,marginTop:"6px"}}            
        label="Include Unconfigured Events"
          labelPlacement="end"
          />
    </Grid>
    <Grid key={8} item xs={2}>
    <Button style={{
                marginLeft: "0px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "65px",
                paddingRight: "65px",
                marginRight: "0px"
              }} onClick={handleSearch}>Search</Button>
     </Grid>          
    </Grid>
    </div>
    <AdminControlsDataGrid columns= { columns} rows = {searchValue} width={"90%"}   />          
  </div>); 
}

export default SESearchEventsPage;